'use client';

import { usePathname } from 'next/navigation';

import { FacebookShareButton, TwitterShareButton, PinterestShareButton } from 'react-share';
import { FaFacebookF, FaTwitter, FaPinterest } from 'react-icons/fa6';

export default function SNSShare({ data }: { data: any }) {
    const SiteBaseUrl = process.env.NEXT_PUBLIC_STRAPI_URL_EXTERNAL;
    // console.dir(SiteBaseUrl);

    const PageUrl = usePathname();
    // console.dir(PageUrl);

    const shareUrl = `${SiteBaseUrl}${PageUrl}`;
    // console.dir(shareUrl);

    const { Title } = data;

    return (
        <>
            <section className={`bg-[#FFFFFF]`}>
                <div className={`mx-auto max-w-[793px] pt-10`}>
                    <div className={`flex gap-10 justify-center`}>
                        {/* <p>{shareUrl}</p> */}
                        <FacebookShareButton url={shareUrl} title={Title}>
                            <FaFacebookF className={`text-[20px] text-gray-500`} />
                        </FacebookShareButton>
                        <TwitterShareButton url={shareUrl} title={Title}>
                            <FaTwitter className={`text-[20px] text-gray-500`} />
                        </TwitterShareButton>
                        <PinterestShareButton url={shareUrl} media={shareUrl}>
                            <FaPinterest className={`text-[20px] text-gray-500`} />
                        </PinterestShareButton>
                    </div>
                    <hr className="border-t-1 border-gray-400 my-8" />
                </div>
            </section>
        </>
    );
}
